'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitQuestionnaire = exports.getQuestionnaire = exports.checkEligibility = exports.updateEligibilityCheck = exports.pushApplicantData = exports.submitEligibilityCheck = exports.updateQuotes = exports.updateLiveQuote = exports.pushApplicationData = exports.submitApplication = exports.getApplicationConfirmation = exports.getApplicationQuote = exports.getFormConfiguration = exports.getAuthorization = exports.errorQuestionnaireData = exports.submitQuestionnaireData = exports.getQuestionnaireData = exports.getEligibilityError = exports.getEligibilityComplete = exports.getMshQuoteComplete = exports.postCreateAppComplete = exports.postCreateAppInit = exports.getConfirmationTextComplete = exports.getConfirmationTextInit = exports.getAppQuoteComplete = exports.getAppQuoteInit = exports.getFormConfigComplete = exports.getFormConfigInit = exports.postAuthComplete = exports.postAuthInit = exports.resetMshQuote = exports.formError = undefined;

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _string = require('lodash/string');

var _Constants = require('./Constants');

var Constants = _interopRequireWildcard(_Constants);

var _Methods = require('../requests/Methods');

var Methods = _interopRequireWildcard(_Methods);

var _handleError = require('../requests/handleError');

var _handleError2 = _interopRequireDefault(_handleError);

var _makeHeaders = require('../requests/makeHeaders');

var _makeHeaders2 = _interopRequireDefault(_makeHeaders);

var _application = require('../transformers/msh/global2go/application');

var _application2 = _interopRequireDefault(_application);

var _applicants = require('../transformers/msh/livexpat/applicants');

var _applicants2 = _interopRequireDefault(_applicants);

var _questionnaire = require('../transformers/msh/global2go/questionnaire');

var _questionnaire2 = _interopRequireDefault(_questionnaire);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Flux Standard Action object.
 * @typedef {Object} FSA
 */

/**
 * Generates an action creator. Adheres to Flux Standard Action (https://github.com/acdlite/flux-standard-action).
 * @param {String} type - Type of the action. Must be one of the defined action constants.
 * @returns {Function} Function which generates this action.
 */
var makeActionCreator = function makeActionCreator(type) {
  return function () {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return {
      type: type,
      payload: payload,
      error: error,
      meta: meta
    };
  };
};

var formError = exports.formError = makeActionCreator(Constants.FORM_ERROR);

var resetMshQuote = exports.resetMshQuote = makeActionCreator(Constants.RESET_MSH_QUOTE);

/**
 * Async action creators
 */

// auth API
var postAuthInit = exports.postAuthInit = makeActionCreator(Constants.POST_AUTH_INIT);
var postAuthComplete = exports.postAuthComplete = makeActionCreator(Constants.POST_AUTH_COMPLETE);

// GET /configuration/{source}/form
var getFormConfigInit = exports.getFormConfigInit = makeActionCreator(Constants.GET_FORM_CONFIG_INIT);
var getFormConfigComplete = exports.getFormConfigComplete = makeActionCreator(Constants.GET_FORM_CONFIG_COMPLETE);

// GET /quote/{source}/{applicationId}
var getAppQuoteInit = exports.getAppQuoteInit = makeActionCreator(Constants.GET_APP_QUOTE_INIT);
var getAppQuoteComplete = exports.getAppQuoteComplete = makeActionCreator(Constants.GET_APP_QUOTE_COMPLETE);

// GET /confirmation/{source}/{applicationId}
var getConfirmationTextInit = exports.getConfirmationTextInit = makeActionCreator(Constants.GET_CONFIRMATION_TEXT_INIT);
var getConfirmationTextComplete = exports.getConfirmationTextComplete = makeActionCreator(Constants.GET_CONFIRMATION_TEXT_COMPLETE);

// POST /application/{source}
var postCreateAppInit = exports.postCreateAppInit = makeActionCreator(Constants.POST_CREATE_APP_INIT);
var postCreateAppComplete = exports.postCreateAppComplete = makeActionCreator(Constants.POST_CREATE_APP_COMPLETE);

var getMshQuoteComplete = exports.getMshQuoteComplete = makeActionCreator(Constants.GET_MSH_QUOTE_COMPLETE);

var getEligibilityComplete = exports.getEligibilityComplete = makeActionCreator(Constants.GET_ELIGIBILITY_COMPLETE);
var getEligibilityError = exports.getEligibilityError = makeActionCreator(Constants.GET_ELIGIBILITY_ERROR);

var getQuestionnaireData = exports.getQuestionnaireData = makeActionCreator(Constants.GET_QUESTIONNAIRE_DATA);
var submitQuestionnaireData = exports.submitQuestionnaireData = makeActionCreator(Constants.SUBMIT_QUESTIONNAIRE_DATA);
var errorQuestionnaireData = exports.errorQuestionnaireData = makeActionCreator(Constants.ERROR_QUESTIONNAIRE_DATA);

/**
 * Generates an async thunk which dispatches actions for an HTTP request.
 * @param {Object} options - Options specifying how the thunk behaves.
 * @returns {Function} The thunk.
 */
var makeAsyncRequestDispatcher = function makeAsyncRequestDispatcher(options) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var response, errors;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(options.preRequestDispatch());
              _context.next = 3;
              return options.fetchResult();

            case 3:
              response = _context.sent;
              _context.prev = 4;
              _context.t0 = dispatch;
              _context.t1 = options;
              _context.next = 9;
              return (0, _handleError2.default)(response).json();

            case 9:
              _context.t2 = _context.sent;
              _context.t3 = _context.t1.postRequestDispatch.call(_context.t1, _context.t2, false);
              return _context.abrupt('return', (0, _context.t0)(_context.t3));

            case 14:
              _context.prev = 14;
              _context.t4 = _context['catch'](4);
              _context.next = 18;
              return response.json();

            case 18:
              errors = _context.sent;
              return _context.abrupt('return', dispatch(options.postRequestDispatch(errors, true)));

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[4, 14]]);
    }));

    return function (_x4) {
      return _ref.apply(this, arguments);
    };
  }();
};

/**
 * GET actions
 */

/**
 * Dispatches an action to get an authorization token from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @returns {Function} A thunk.
 */
var getAuthorization = exports.getAuthorization = function getAuthorization(source, lang) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return postAuthInit({ source: source });
    },
    fetchResult: function fetchResult() {
      return Methods.post('' + (0, _string.trimEnd)(_config2.default.msh_auth_api, '/'), (0, _makeHeaders2.default)(lang));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? postAuthComplete(payload, true) : postAuthComplete({ source: source, data: payload });
    }
  });
};

/**
 * Dispatches an action to get the form configuration for a source from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @returns {Function} A thunk.
 */
var getFormConfiguration = exports.getFormConfiguration = function getFormConfiguration(product, source, lang, auth) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getFormConfigInit({ product: product });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.msh_api, '/') + '/configuration/' + product + '/' + source + '/form', (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getFormConfigComplete(payload, true) : getFormConfigComplete({ source: source, data: payload });
    }
  });
};

/**
 * Dispatches an action to get the quote for an application from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID for the application.
 * @returns {Function} A thunk.
 */
var getApplicationQuote = exports.getApplicationQuote = function getApplicationQuote(source, lang, auth, applicationId) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getAppQuoteInit({ source: source, applicationId: applicationId });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.msh_api, '/') + '/quote/' + source + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getAppQuoteComplete(payload, true) : getAppQuoteComplete({ source: source, applicationId: applicationId, data: payload });
    }
  });
};

/**
 * Dispatches an action to get the confirmation text for an application from the API.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID for the application.
 * @returns {Function} A thunk.
 */
var getApplicationConfirmation = exports.getApplicationConfirmation = function getApplicationConfirmation(product, lang, auth, applicationId) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getConfirmationTextInit({ product: product, applicationId: applicationId });
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.msh_api, '/') + '/confirmation/' + product + '/' + applicationId, (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getConfirmationTextComplete(payload, true) : getConfirmationTextComplete({ product: product, applicationId: applicationId, data: payload });
    }
  });
};

/**
 * POST actions
 */

/**
 * Dispatches an action to create a new application.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {Object} applicationData - Initial data for the application.
 * @returns {Function} A thunk.
 */
var submitApplication = exports.submitApplication = function submitApplication(product, provider, lang, auth, applicationData, createApplication) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return postCreateAppInit({ product: product, applicationData: applicationData });
    },
    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.msh_api, '/') + '/application/' + product + '/' + provider + (createApplication ? '/create' : ''), (0, _makeHeaders2.default)(lang, auth), applicationData);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? postCreateAppComplete(payload, true) : postCreateAppComplete({ product: product, data: payload });
    }
  });
};

/**
 * Convenience methods for combining some API requests.
 */

/**
 * Dispatches an action to update an application, or create it if it doesn't exist.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to update. A new application will
 *                                 be created first if an empty value is given.
 * @param {Object} [applicationData=null] - Data to create an application with, if necessary.
 * @returns {Function} A thunk.
 */
var pushApplicationData = exports.pushApplicationData = function pushApplicationData(product, provider, lang, auth, createApplication, applicationId) {
  var applicationData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', dispatch(submitApplication(product, provider, lang, auth, applicationData, createApplication)));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function (_x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }();
};

/**
 * Dispatches an action to update the quote on the form, creating the application if necessary.
 * @param {String} source - Name of the client.
 * @param {String} lang - The app's language.
 * @param {Object} auth - Authorization for the request.
 * @param {String} applicationId - ID of the application to get a quote for. A new application will
 *                                 be created first if an empty value is given.
 * @param {Object} [applicationData=null] - Data to create an application with, if necessary.
 * @returns {Function} A thunk.
 */
var updateLiveQuote = exports.updateLiveQuote = function updateLiveQuote(product, provider, lang, auth, createApplication, applicationId) {
  var applicationData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var applicantData = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var response;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (getState().api.requestStatus.GET_APP_QUOTE) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return dispatch(pushApplicationData(product, provider, lang, auth, createApplication, applicationId, applicationData));

            case 3:
              response = _context3.sent;
              return _context3.abrupt('return', response.error ? dispatch(resetMshQuote({ data: response.payload })) : dispatch(getMshQuoteComplete({ product: product, applicationId: applicationId, data: response.payload })));

            case 5:
              return _context3.abrupt('return', Promise.resolve());

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function (_x10, _x11) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/**
 * Dispatches an action to call updateLiveQuote
 * @param {String} createApplication - boolean createApplication
 * @param {String} params - parameters to be passed
 * @returns {Function} A thunk.
 */
var updateQuotes = exports.updateQuotes = function updateQuotes(createApplication, params) {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var applicationData;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              applicationData = { application: (0, _application2.default)(params.values), applicants: params.values.applicants };

              dispatch(updateLiveQuote(params.formName, params.provider, params.params.language, params.auth, createApplication, params.msh.id, applicationData));

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function (_x12, _x13) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var submitEligibilityCheck = exports.submitEligibilityCheck = function submitEligibilityCheck(product, provider, lang, auth, applicantData) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return postCreateAppInit({ product: product, applicantData: applicantData });
    },
    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.msh_api, '/') + '/applicant/' + product + '/' + provider, (0, _makeHeaders2.default)(lang, auth), applicantData);
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? postCreateAppComplete(payload, true) : postCreateAppComplete({ product: product, data: payload });
    }
  });
};

var pushApplicantData = exports.pushApplicantData = function pushApplicantData(product, provider, lang, auth) {
  var applicantData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt('return', dispatch(submitEligibilityCheck(product, provider, lang, auth, applicantData)));

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, undefined);
    }));

    return function (_x15, _x16) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var updateEligibilityCheck = exports.updateEligibilityCheck = function updateEligibilityCheck(product, provider, lang, auth) {
  var applicantData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var response;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (getState().api.requestStatus.GET_APP_QUOTE) {
                _context6.next = 5;
                break;
              }

              _context6.next = 3;
              return dispatch(pushApplicantData(product, provider, lang, auth, applicantData));

            case 3:
              response = _context6.sent;
              return _context6.abrupt('return', response.error ? dispatch(getEligibilityError({ data: response.payload })) : dispatch(getEligibilityComplete({ data: 'aa' })));

            case 5:
              return _context6.abrupt('return', Promise.resolve());

            case 6:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, undefined);
    }));

    return function (_x18, _x19) {
      return _ref6.apply(this, arguments);
    };
  }();
};

/**
 * Dispatches an action to call updateLiveQuote
 * @param {String} createApplication - boolean createApplication
 * @param {String} params - parameters to be passed
 * @returns {Function} A thunk.
 */
var checkEligibility = exports.checkEligibility = function checkEligibility(params) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      var applicantData;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              applicantData = { applicants: (0, _applicants2.default)(params.values) };

              dispatch(updateEligibilityCheck(params.formName, params.provider, params.params.language, params.auth, applicantData));

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, undefined);
    }));

    return function (_x20, _x21) {
      return _ref7.apply(this, arguments);
    };
  }();
};

var getQuestionnaire = exports.getQuestionnaire = function getQuestionnaire(product, id, lang, auth) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getFormConfigInit({});
    },
    fetchResult: function fetchResult() {
      return Methods.get((0, _string.trimEnd)(_config2.default.msh_api, '/') + '/questionnaire/' + product + '/' + id, (0, _makeHeaders2.default)(lang, auth));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? getQuestionnaireData(false) : getQuestionnaireData(payload);
    }
  });
};

var submitQuestionnaire = exports.submitQuestionnaire = function submitQuestionnaire(params, signature) {
  return makeAsyncRequestDispatcher({
    preRequestDispatch: function preRequestDispatch() {
      return getFormConfigInit({});
    },
    fetchResult: function fetchResult() {
      return Methods.post((0, _string.trimEnd)(_config2.default.msh_api, '/') + '/questionnaire/' + params.provider + '/' + params.questionnaireId, (0, _makeHeaders2.default)(params.params.language, params.auth), (0, _questionnaire2.default)(params.values, signature));
    },
    postRequestDispatch: function postRequestDispatch(payload, isError) {
      return isError ? errorQuestionnaireData(payload) : submitQuestionnaireData(payload);
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/actions/MshActionCreators.js
// module id = 122
// module chunks = 0